import { LinearProgress } from '@mui/material';
import React from 'react';

export default function LoadingAnimation(props) {
    return <LinearProgress color="secondary" {...props} />
}